import { render, staticRenderFns } from "./ReaderPhotos.vue?vue&type=template&id=4a7678b8&"
import script from "./ReaderPhotos.vue?vue&type=script&lang=ts&"
export * from "./ReaderPhotos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports